<template>
  <v-container
    fluid
  >
    <base-material-card
      inline
      icon="mdi-account-group"
      title="Groups"
    >
      <v-card-actions>
        <v-btn
          color="primary"
          @click="addGroup"
        >Add</v-btn>
      </v-card-actions>
      <data-table
        ref="table"
        :fetch-from="fetchForm"
        :fields="fields"
      >
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            @click="editGroup(slotData.rowData)"
            x-small
            color="primary"
          >Edit</v-btn>
        </template>
      </data-table>
      <modal-form
        v-if="selectedGroup"
        title="Group"
        :show="dialog"
        @update:show="dialog=$event"
        v-on:saveData="doSave"
      >
        <v-form
          v-model="valid"
          ref="form"
          v-if="selectedGroup"
        >

          <v-row>
            <v-col cols="4">
                <text-field
                  label="Group name"
                  :value="getValue(selectedGroup, 'name')"
                  @input="setValue(selectedGroup, 'name', $event)"
                ></text-field>
            </v-col>
            <v-col cols="8">
              <text-field
                label="Sites"
                :value="getValue(selectedGroup, 'sites')"
                @input="setValue(selectedGroup, 'sites', $event)"
              ></text-field>
            </v-col>
          </v-row>
          <v-tabs
            v-model="tab"
          >
            <v-tab>Views</v-tab>
            <v-tab>Sites</v-tab>
          </v-tabs>
          <v-row>
            <v-col>
              <v-tabs-items
                v-model="tab"
              >
                <v-tab-item>
                  <v-row>
                    <v-col cols="3">
                      <h4>Tenants</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_tenants', 0)"
                        @change="setValue(selectedGroup, 'view_tenants', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Rollout</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_rollout', 0)"
                        @change="setValue(selectedGroup, 'view_rollout', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Contracts</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_contracts', 0)"
                        @change="setValue(selectedGroup, 'view_contracts', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Equipment air conditioning</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_equipment_air_conditioning', 0)"
                        @change="setValue(selectedGroup, 'view_equipment_air_conditioning', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Equipment DC system</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_equipment_dc_system', 0)"
                        @change="setValue(selectedGroup, 'view_equipment_dc_system', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Equipment battery</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_equipment_battery', 0)"
                        @change="setValue(selectedGroup, 'view_equipment_battery', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Equipment shelter</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_equipment_shelter', 0)"
                        @change="setValue(selectedGroup, 'view_equipment_shelter', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Permits ministry of health</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_health_permits', 0)"
                        @change="setValue(selectedGroup, 'view_health_permits', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Sectors</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_sectors', 0)"
                        @change="setValue(selectedGroup, 'view_sectors', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Cells</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_cells', 0)"
                        @change="setValue(selectedGroup, 'view_cells', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Projects</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_projects', 0)"
                        @change="setValue(selectedGroup, 'view_projects', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'edit_projects', 0)"
                        @change="setValue(selectedGroup, 'edit_projects', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Contacts</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'view_contacts', 0)"
                        @change="setValue(selectedGroup, 'view_contacts', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'edit_contacts', 0)"
                        @change="setValue(selectedGroup, 'edit_contacts', $event)"
                      ></switch-button>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row>
                    <v-col cols="3">
                      <h4>Access</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'access_can_view', 0)"
                        @change="setValue(selectedGroup, 'access_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'access_can_edit', 0)"
                        @change="setValue(selectedGroup, 'access_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Construction</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'construction_can_view', 0)"
                        @change="setValue(selectedGroup, 'construction_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'construction_can_edit', 0)"
                        @change="setValue(selectedGroup, 'construction_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Construction equipment</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'construction_equipment_can_view', 0)"
                        @change="setValue(selectedGroup, 'construction_equipment_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'construction_equipment_can_edit', 0)"
                        @change="setValue(selectedGroup, 'construction_equipment_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Contract</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'constract_can_view', 0)"
                        @change="setValue(selectedGroup, 'constract_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'constract_can_edit', 0)"
                        @change="setValue(selectedGroup, 'constract_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Design</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'design_can_view', 0)"
                        @change="setValue(selectedGroup, 'design_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'design_can_edit', 0)"
                        @change="setValue(selectedGroup, 'design_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Location</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'location_can_view', 0)"
                        @change="setValue(selectedGroup, 'location_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'location_can_edit', 0)"
                        @change="setValue(selectedGroup, 'location_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Permit ministry of health</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'permit_ministry_of_health_can_view', 0)"
                        @change="setValue(selectedGroup, 'permit_ministry_of_health_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'permit_ministry_of_health_can_edit', 0)"
                        @change="setValue(selectedGroup, 'permit_ministry_of_health_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Tenant</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'tenant_can_view', 0)"
                        @change="setValue(selectedGroup, 'tenant_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'tenant_can_edit', 0)"
                        @change="setValue(selectedGroup, 'tenant_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                    <v-col cols="3">
                      <h4>Transmission</h4>
                      <switch-button
                        label="View"
                        :value="getValueDefault(selectedGroup, 'transmission_can_view', 0)"
                        @change="setValue(selectedGroup, 'transmission_can_view', $event)"
                      ></switch-button>
                      <switch-button
                        label="Edit"
                        :value="getValueDefault(selectedGroup, 'transmission_can_edit', 0)"
                        @change="setValue(selectedGroup, 'transmission_can_edit', $event)"
                      ></switch-button>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>

        </v-form>
      </modal-form>
    </base-material-card>
  </v-container>
</template>

<script>
  import DataTable from '@/components/DataTable'
  import GroupService from '@/services/group'
  import ModalForm from '@/components/ModalForm'
  import TextField from '@/components/TextField'
  import ReactivitMixin from '@/mixins/Reactivity'
  import SwitchButton from '@/components/SwitchButton'

  export default {
    name: 'Group',
    components: { SwitchButton, TextField, ModalForm, DataTable },
    mixins: [
      ReactivitMixin,
    ],
    data: () => ({
      tab: 0,
      dialog: false,
      selectedGroup: undefined,
      fields: [
        {
          name: 'name',
          title: 'Group',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
    }),
    methods: {
      fetchForm (urls, options) {
        const us = new GroupService()
        return us.list(options.params)
      },
      addGroup () {
        this.selectedGroup = {}
        this.dialog = true
      },
      editGroup (data) {
        this.selectedGroup = JSON.parse(JSON.stringify(data))
        this.dialog = true
      },
      doSave () {
        const gs = new GroupService()
        if (this.selectedGroup.id) {
          // save edited group
          gs.put(this.selectedGroup.id, this.selectedGroup).then((response) => {
            this.dialog = false
            this.$refs.table.refresh()
          })
        } else {
          gs.post(this.selectedGroup).then((response) => {
            this.dialog = false
            this.$refs.table.refresh()
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
